(function () {
    angular
        .module('customeDirectivesModule')
        .directive('imageSizeLimitation', function () {
            return {
                restrict: 'A',
                scope: {
                    maximumWidth: '=',
                    maximumHeight: '='
                },
                link: link
            };
        });

    function link(scope, element, attrs) {
        element.bind('load', function () {
            if (!scope.maximumWidth || !scope.maximumHeight) {
                return;
            }

            if (this.width > this.height) {
                $(this).css({ 'max-width': scope.maximumWidth + 'px' });
                $(this).css({ 'display': 'block' });
            } else {
                $(this).css({ 'max-height': scope.maximumHeight + 'px' });
                $(this).css({ 'display': 'block' });
            }
        });
    }
})();